import type { TreePickerItem } from '@ipfabric/ui-components/TreePicker/helpers/TreePickerItem';

// Snapshot trigger leaves map to the `action` of a snapshot event.
const SNAPSHOT_ACTIONS = [
  'discover',
  'clone',
  'delete',
  'download',
  'load',
  'unload',
] as const;

// Intent verification trigger leaves map to the `action` of a snapshot event.
const INTENT_VERIF_ACTIONS = ['calculate'] as const;

// Status common to both types
const STATUSES = [
  'started',
  'completed',
  'failed',
  'resumed',
  'resumed (stopping)',
  'stopped',
] as const;

/**
 * Tree of selectable webhook triggers presented in the TreePicker. Leaf keys
 * are `<type>/<value>` so the selection can later be reconstructed into the
 * `{ type, action | status }` trigger conditions stored on the webhook.
 */
export const TRIGGER_TREE_ITEMS: TreePickerItem<string>[] = [
  {
    key: 'snapshot',
    label: 'Snapshot',
    children: SNAPSHOT_ACTIONS.map((action) => ({
      key: `snapshot/${action}`,
      label: action,
      children: STATUSES.map((status) => ({
        key: `snapshot/${action}/${status}`,
        label: status,
        children: [],
      })),
    })),
  },
  {
    key: 'intent-verification',
    label: 'Intent verification',
    children: INTENT_VERIF_ACTIONS.map((action) => ({
      key: `intent-verification/${action}`,
      label: action,
      children: STATUSES.map((status) => ({
        key: `intent-verification/${action}/${status}`,
        label: status,
        children: [],
      })),
    })),
  },
];
